export enum MonthDaysEnum {
  FIRST = 1,
  FIFTEENTH = 15,
  LAST = 'L',
  BEFORE_LAST = 'L-1',
}
